module.exports = __webpack_public_path__ + "img/goodImg.5f1a722c.png";